<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="content">
    <div class="header">
      <Header :tabIndex="tabIndex"></Header>
      <el-image
        class="head_bg"
        fit="cover"
        src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/about/header_bg.png"
      ></el-image>
      <div class="texts">
        <div class="text">关于我们</div>
        <div class="text1">二白的故事里，藏着一份最纯粹的执着</div>
        <div class="text1">以赤子般的热忱，构建人与数字生命体的新关系</div>
      </div>
    </div>
    <div class="nav">
      <div class="nav_head">
        <div
          class="item"
          :class="item.img != '' ? 'item1' : 'item2'"
          v-for="(item, index) in nav_head"
          :key="index"
        >
          <div class="img" v-if="item.img != ''"></div>
          <div class="title">{{ item.title }}</div>
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
      <div class="nav_item">
        <div class="nav_item_title">四大核心技术</div>
        <div class="nav_item_info">
          <div
            class="info_item"
            v-for="(item, index) in item_info"
            :key="index"
            @mouseenter="changeIsShow(index, 0)"
            @mouseleave="changeIsShow(index, 1)"
          >
            <div class="info_item_ite" v-if="!item.isHover">
              <el-image class="img" fit="cover" :src="item.img"></el-image>
              <div class="texts">
                <div class="text">{{ item.text }}</div>
                <div class="text1">{{ item.text1 }}</div>
              </div>
            </div>
            <div class="info_item_ite1" v-else>
              <div class="ite">
                <div class="title" v-if="item.title != undefined">
                  {{ item.title }}
                </div>
                <div class="text">{{ item.text2 }}</div>
              </div>
              <div class="ite">
                <div class="title" v-if="item.title1 != undefined">
                  {{ item.title1 }}
                </div>
                <div class="text">{{ item.text3 }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="nav_item nav_item1">
        <div class="nav_item_title">产品发展历程</div>
        <div class="nav_item_info1">
          <el-image
            class="line"
            fit="cover"
            src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/about/gy_7.png"
          ></el-image>
          <div
            class="info_item"
            v-for="(item, index) in item_info1"
            :key="index"
          >
            <div class="item" :class="'item' + index">
              <div class="time" :style="{ color: item.color }">
                {{ item.time }}
              </div>
              <div class="text">{{ item.text }}</div>
              <el-image class="img" fit="cover" :src="item.img"></el-image>
            </div>
          </div>
        </div>
        <div class="nav_item_foot">
          <el-image
            class="img"
            fit="cover"
            src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/about/gy_tu6.png"
          ></el-image>
          <div class="text">核心定位</div>
          <div class="text1">
            情绪陪伴与治愈，主打“可养成、可陪伴、可成长”的数字生命体
          </div>
        </div>
      </div>
      <div class="nav_item2">
        <div class="title">联系我们</div>
        <div class="item" v-for="(item, index) in item_info2" :key="index">
          <div class="item_head">
            <div class="image">
              <el-image class="img" fit="cover" :src="item.img"></el-image>
            </div>
            <div class="line"></div>
            <div class="itme_foot">
              <div class="text">
                {{ item.text }}
              </div>
              <div class="text1">
                {{ item.text1 }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/header.vue"
import Footer from "@/components/footer.vue"

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      tabIndex: 5,
      nav_head: [
        {
          title: "我们始终相信，\n数字世界不该是冰冷的算法丛林",
          text: "那些流动的代码里，理应生长出理解与共鸣\n那些闪烁的屏幕后，本该藏着对每一份情绪的承接\n所以我们慢慢来，像培育一株会呼吸的植物",
          img: "",
        },
        {
          title: "",
          text: "",
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/about/gy_1.png",
        },
        {
          title: "",
          text: "",
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/about/gy_2.png",
        },
        {
          title: "让科技褪去机械的外壳，\n成为能感知喜怒哀乐的伙伴",
          text: "这便是二白存在的意义\n在科技与人文的交汇处，开辟一片能安放情绪的天地",
          img: "",
        },
      ],
      item_info: [
        {
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/about/gy_3.png",
          text: "自研性格生成算法",
          text1: "让每个机器人都是 “独一无二的伙伴”",
          isHover: false,
          title: "初始差异化：",
          text2:
            "预生成数十万个性格特征迥异的数字生命体，从源头避免 “千机一面”",
          title1: "后天共生性：",
          text3: "通过用户互动数据动态调整性格倾向，实现 “和而不同” 的长期关系",
        },
        {
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/about/gy_4.png",
          text: "稀疏记忆架构",
          text1: "让机器人 “记得住、用得对” 关键瞬间",
          isHover: false,
          text2:
            "基于大模型 + 向量数据库 + 自研稀疏记忆架构，构建 “分层记忆系统”",
          text3: "解决 “长期陪伴” 核心痛点，让陪伴有 “时间的厚度”",
        },
        {
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/about/gy_5.png",
          text: "情感引擎",
          text1: "让交互有 “情绪流动感”",
          isHover: false,
          title: "自研情感引擎：",
          text2:
            "机器人的情绪并非孤立反应，而是随用户互动、时间推移形成 “情绪曲线”",
          title1: "差异化输出：",
          text3:
            "相同输入因机器人当下情绪不同而有不同回应，让陪伴更像 “真实关系”",
        },
        {
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/about/gy_6.png",
          text: "自然交互技术",
          text1: "消除 “AI 感”，让陪伴更自然",
          isHover: false,
          text2: "融合硬件触摸、环境感知与语音交互，实现 “无唤醒词触发”",
          text3: "生物性自然交互，复刻真实陪伴中的自然感与亲昵感",
        },
      ],
      item_info1: [
        {
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/about/gy_tu.png",
          time: "2018年5月",
          text: "二白机器人Demo亮相",
          color: "#7C65FF",
        },
        {
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/about/gy_tu2.png",
          time: "2024年8月",
          text: "启动二白机器人量产计划",
          color: "#3092FF",
        },
        {
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/about/gy_tu3.png",
          time: "2025年6月10日",
          text: "推出首款机器人产品二白Mini机器人",
          color: "#FF8C00",
        },
        {
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/about/gy_tu4.png",
          time: "2025年6月15日",
          text: "二白Mini机器人创始版1000台售罄",
          color: "#FF6AE1",
        },
        {
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/about/gy_tu5.png",
          time: "2025年7月10日",
          text: "二白Mini机器人限定版开售",
          color: "#77FFA4",
        },
      ],
      item_info2: [
        {
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/about/gy_tu7.png",
          text: "公司名称",
          text1: "二白智能科技有限公司",
        },
        {
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/about/gy_tu8.png",
          text: "联系方式",
          text1: "robot_by@163.com",
        },
        {
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/about/gy_tu9.png",
          text: "联系地址",
          text1: "浙江省杭州市萧山区机器人中心A座",
        },
      ],
    }
  },
  mounted() {},
  methods: {
    changeIsShow(index, e) {
      if (e == 0) {
        this.item_info[index].isHover = true
      } else {
        this.item_info[index].isHover = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.content {
  position: relative;
  .header {
    width: 100%;
    .head_bg {
      width: 100%;
      top: 0;
      left: 0;
      z-index: 1;
    }
    .texts {
      position: absolute;
      top: 40vh;
      left: 150px;
      z-index: 2;
      .text {
        font-size: calc(60px * var(--scale));
        font-weight: bold;
        color: #fff;
        text-align: left;
      }
      .text1 {
        font-size: calc(24px * var(--scale));
        color: #747477;
        text-align: left;
        white-space: pre-line;
      }
    }
  }
  .nav {
    margin-top: 100px;
    padding: 0 160px;
    margin-bottom: 30px;
    .nav_head {
      width: 100%;
      padding: 0 100px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-bottom: 60px;
      .item {
        color: #fff;
        border-radius: 20px;
        margin-bottom: 30px;
        .title {
          font-size: calc(24px * var(--scale));
          font-weight: bold;
          margin-bottom: 20px;
          white-space: pre-line;
          text-align: left;
        }
        .text {
          font-size: calc(20px * var(--scale));
          font-weight: 200;
          white-space: pre-line;
          text-align: left;
        }
      }
      .item1 {
        width: 35%;
        border-radius: 20px;
      }
      .item2 {
        width: 60%;
        padding: 30px;
        box-sizing: border-box;
        background: linear-gradient(to bottom, #1a1e27 0%, #040811 100%);
      }
      .item:nth-child(2) {
        .img {
          width: 100%;
          height: 100%;
          background-image: url("https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/about/gy_1.png");
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
      }
      .item:nth-child(3) {
        .img {
          width: 100%;
          height: 100%;
          background-image: url("https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/about/gy_2.png");
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
      }
    }
    .nav_item {
      padding: 0 100px;
      margin-bottom: 30px;
      .nav_item_title {
        font-size: calc(46px * var(--scale));
        font-weight: bold;
        color: #fff;
        text-align: center;
        margin-bottom: 20px;
      }
      .nav_item_info {
        display: grid;
        grid-row-gap: 2rem;
        grid-column-gap: 2rem;
        grid-template-rows: auto;
        grid-template-columns: repeat(2, 2fr);
        flex: 1;
        .info_item {
          width: 100%;
          height: 100%;
          .info_item_ite {
            height: 100%;
            padding: 30px;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            background-color: #0f0f12;
            border-radius: 20px;
            .img {
              width: 120px;
              margin-bottom: 60px;
            }
            .texts {
              text-align: left;
              .text {
                color: #fff;
                font-size: calc(34px * var(--scale));
              }
              .text1 {
                color: #878788;
                font-size: calc(28px * var(--scale));
              }
            }
          }
        }
        .info_item_ite1 {
          height: 100%;
          padding: 20px 30px;
          box-sizing: border-box;
          display: flex;
          justify-content: center;
          flex-direction: column;
          background-color: #0f0f12;
          border-radius: 20px;
          // animation: fadeInOut 1.5s infinite forwards;
          .ite {
            margin-bottom: 20px;
          }
          .title {
            color: #fff;
            font-weight: 600;
            text-align: left;
            font-size: calc(30px * var(--scale));
          }
          .text {
            color: #878788;
            text-align: left;
            font-size: calc(28px * var(--scale));
          }
        }
        @keyframes fadeInOut {
          0% {
            opacity: 0;
          }
          50% {
            opacity: .5;
          }
          100% {
            opacity: 1;
          }
        }

        .fading {
          animation: fadeInOut 3s infinite;
        }
      }
    }
    .nav_item1 {
      width: 100%;
      padding: 0 100px;
      box-sizing: border-box;
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .nav_item_info1 {
        width: 100%;
        margin-top: 20px;
        position: relative;

        .line {
          height: 2000px;
        }
        .info_item {
          width: 100%;
          .item {
            width: 100%;
            position: absolute;
            font-size: calc(26px * var(--scale));
            display: flex;
            align-items: start;
            justify-content: center;
            flex-direction: column;
            box-sizing: border-box;
            .text {
              color: #fff;
            }
            .img {
              width: 200px;
              margin-top: 40px;
            }
          }
          .item0 {
            top: 4%;
            left: 0;
            padding-left: 57%;
          }
          .item1 {
            top: 24%;
            left: 0;
            align-items: end;
            padding-right: 57%;
          }
          .item2 {
            top: 42%;
            left: 0;
            padding-left: 57%;
          }
          .item3 {
            top: 62%;
            left: 0;
            align-items: end;
            padding-right: 57%;
          }
          .item4 {
            top: 79%;
            left: 0;
            padding-left: 57%;
          }
        }
        .info_item:nth-child(odd) {
          .item {
            text-align: right;
          }
        }
        .info_item:nth-child(even) {
          .item {
            text-align: left;
          }
        }
      }
      .nav_item_foot {
        width: 70%;
        margin-top: 40px;
        position: relative;
        .text {
          width: 100%;
          color: #fff;
          font-size: calc(20px * var(--scale));
          text-align: center;
          position: absolute;
          top: 32%;
        }
        .text1 {
          width: 100%;
          color: #fff;
          font-size: calc(20px * var(--scale));
          text-align: center;
          position: absolute;
          top: 50%;
        }
      }
    }
    .nav_item2 {
      display: grid;
      grid-row-gap: 2rem;
      grid-column-gap: 2rem;
      grid-template-rows: auto;
      grid-template-columns: repeat(3, 1fr);
      flex: 1;
      position: relative;
      .title {
        font-size: calc(50px * var(--scale));
        color: #fff;
        position: absolute;
        left: 0;
        top: 10px;
      }
      .item {
        padding: 20px;
        padding-bottom: 50px;
        .image {
          height: 190px;
          display: flex;
          align-items: self-end;
          justify-content: start;
          padding-top: 50px;
          box-sizing: border-box;

          .img {
            width: 70px;
          }
        }
        .line {
          width: 100%;
          height: 2px;
          background: linear-gradient(
            to right,
            #424245 0%,
            rgba(115, 115, 115, 0) 100%
          );
          margin: 15px 0;
        }
        .itme_foot {
          text-align: left;
          .text {
            color: #808082;
            font-size: calc(20px * var(--scale));
            margin-bottom: 20px;
          }
          .text1 {
            color: #fff;
            font-size: calc(24px * var(--scale));
          }
        }
      }
      .item:nth-child(4) {
        .image {
          padding-top: 0;
          .img {
            width: 100%;
            height: 190px;
            border-radius: 20px;
          }
        }
      }
    }
  }
}
</style>
